import customerInstance from '../instance'

const updateDeliveryTypeConfig = (data) => {
	return customerInstance.put('/deliveryTypeConfigs', data)
}

export default updateDeliveryTypeConfig
